
import { deviceType } from "@/helper/util";
import { defineComponent } from "vue";

export default defineComponent({
  name: "GameButton",

  props: {
    alternative: {
      type: String,
      default: "",
    },
    isLarge: {
      type: Boolean,
    },
    isBorderless: {
      type: Boolean,
    },
  },

  computed: {
    extraClasses() {
      return {
        "game-button--large": this.isLarge && this.alternative.length <= 2,
        "game-button--large-small-alt":
          this.isLarge && this.alternative.length > 2,
        "game-button--borderless": this.isBorderless,
      };
    },
    isUserOnDesktop() {
      return deviceType() === "desktop";
    },
  },
});
